import styled, { css } from 'styled-components';
import { DotVariant, StyledDotProps } from './types';
import { DataPoint } from '../DataPoint';

/**
 * Component style.
 */
export const StyledDot = styled(DataPoint)<StyledDotProps>`
  text {
    user-select: none;
  }

  ${({ $variant }) => css`
    circle {
      fill-opacity: ${$variant === DotVariant.hollow ? 1 : 0.7};
    }
  `}

  ${({ $clickable }) =>
    $clickable
      ? css`
          cursor: pointer;

          &:hover,
          &:focus {
            opacity: 0.5;
            outline: none;
          }

          &:focus-visible {
            circle {
              stroke: var(--redsift-color-primary-n);
              stroke-width: 4px;
              paint-order: stroke;
            }
          }
        `
      : ''}
`;
